export const SCRIPT_ADDRESS_TESTNET =
  'addr1q8fwtxy0ks4ewquj4uje6ar9q3zhygkv3m6e7ewn0d8484yh6fw34j5jan65393w9fr8ys0ycfxu5j7dauhw6x48xcpsumrkzs'

export const CARDANO_EXPLORER_TESTNET =
  'https://explorer.mainnet.cardano.org/en/transaction?id='
